import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem 5rem;
  padding: 1rem 2rem;
  justify-content: center;
  @media (min-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    justify-content: unset;
  }
`;

export const CardContainer = styled.div`
  width: 6.25rem;
  margin-top: 0.5rem;
  text-align: center;

  & > span.description {
    font-size: 0.875rem;
    color: ${(p) => p.theme.colors.blue6};
    font-family: ${({ theme }) => theme.fonts.workSans} !important;
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5rem;
  }

  margin-right: 0.675rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    &:not(:last-child) {
      margin-right: 1.25rem;
    }
  }
`;

export const PieceTypesCard = styled.img`
  height: 6.25rem;
  border-radius: 0.312rem;
  margin-bottom: 0.5rem;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center;

  &:hover {
    box-shadow: ${({ theme }) => theme.commoms.boxShadow2};
  }

  &.inside-modal {
    border-radius: 0, 625rem;
    width: 15.5rem;
    height: 15.5rem;
    background-size: 14rem;
    cursor: inherit;

    &:hover {
      box-shadow: inherit;
    }
  }
`;

export const PieceTypesCardLoading = styled.div`
  height: 6.25rem;
  border-radius: 0.312rem;
  margin-bottom: 0.5rem;
  cursor: progress;
`;
